import { render, staticRenderFns } from "./BoardFilterFaqLayout.vue?vue&type=template&id=7af33867&scoped=true"
import script from "./BoardFilterFaqLayout.vue?vue&type=script&lang=js"
export * from "./BoardFilterFaqLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af33867",
  null
  
)

export default component.exports